import { render, staticRenderFns } from "./customer-form.vue?vue&type=template&id=9c69411c&scoped=true&"
import script from "./customer-form.vue?vue&type=script&lang=js&"
export * from "./customer-form.vue?vue&type=script&lang=js&"
import style0 from "./customer-form.vue?vue&type=style&index=0&id=9c69411c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c69411c",
  null
  
)

export default component.exports